// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Header from './Header'
// import Cases from './pages/Cases/Cases';
// import Report from './pages/Report/Report';

// function App() {
//   return (
//     <Router>
//       <Header />
//       <Routes>
//         <Route path="/" element={<Navigate to="/cases" replace />} />
//         <Route path="/cases" element={<Cases />} />
//         <Route path="/report" element={<Report />} />
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;



import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Header from './Header'
import Action from './pages/Actions/Action'
import Report from './pages/Report/Report';
import Footer from './pages/Footer/Footer';
import Cases from './pages/Cases/Cases'


const App = () => {
  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/action" element={<Action />} />
            <Route path="/" element={<Cases />} />
            <Route path="/report" element={<Report />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
